import { DOMAIN } from "../../../../var_env."
import { RequestResponsePattern } from "../../../../types/Request"
import { getApi } from "../../../../utils/requestApi"
import { LinksTutoriaisListaType } from "../types"
import { setLista, setRequestGetData, setRequestGetError, setRequestGetLoading, setRequestGetMessage } from "../Reducers/LinksTutoriaisReducer"

export default async function getListas(dispatch: Function, idUsuario: number) {
    try {
        dispatch(setRequestGetLoading())
        const response: RequestResponsePattern<LinksTutoriaisListaType[]> = await getApi({
            endpoint: DOMAIN,
            params: `/LinksTutoriais/lista?idUsuario=${idUsuario}`,
        })
        if (response && !response.flagErro) {
            dispatch(setRequestGetData(response))
            dispatch(setLista(response.listaResultados))
        } else throw new Error(response?.listaMensagens?.[0] ?? 'Erro na requisição')
    } catch (error: any) {
        dispatch(setRequestGetMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestGetError())
    }
}
